<div class="pinned">
  <div class="title">
    <b>{{ 'archivelabel.type' | translate }}:</b>
    <nb-select [selected]="type" [placeholder]="'select' | translate:{value: 'type' | translate}" (selectedChange)="changeTo($event)">
      <nb-option [value]="null">{{ 'any' | translate }}</nb-option>
      @for (o of types; track o) {
        <nb-option [value]="o">
          {{ 'archivelabel.'+o | translate }}
        </nb-option>
      }
    </nb-select>
  </div>
  <div class="buttons">
    <bst-table-options-button [count]="filterCount" (open)="dualAxisComponent.openOptions('filters')"></bst-table-options-button>
  </div>
</div>
<section>
  <bst-dual-axis #dualAxisComponent [tag]="'archived'" [delegate]="this" [bootstrap]="true"></bst-dual-axis>
</section>


<ng-template #cellTemplate let-item="row" let-column="column" let-node="node">
  @if (column.name === 'name') {
    <div>
      @switch (item.type) {
        @case (ArchiveType.User) {
          <nb-user (click)="preview(item)" class="clickable" color="#eee" [picture]="Globals.storage(item.preview)" [name]="item.name"></nb-user>
        }
        @case (ArchiveType.Client) {
          <nb-user (click)="preview(item)" class="clickable" shape="rectangle" [picture]="Globals.storage(item.preview)" [name]="item.name" color="#f7f9fc"></nb-user>
        }
        @case (ArchiveType.Project) {
          <div (click)="preview(item)" class="project-name">
            <div class="color-preview" [style.background]="item.preview"></div>
            <a>{{ item.name }}</a>
          </div>
        }
        @default {
          <div class="fake-preview">{{ item.name }}</div>
        }
      }
    </div>
  }
  @if (column.name === 'type') {
    <span>
      {{ 'archivelabel.'+item.type | translate }}
    </span>
  }
  @if (column.name === 'archived_at' || column.name === 'created_at') {
    <div class="date-cell">
      <span [nbTooltip]="item[column.name] | date:'long'">{{ item[column.name] | date:'longDate' }}</span>
      @if (ago(item[column.name]); as ag) {
        <span class="small-label">({{ ag <= 1 ? ('daysagoless' | translate) : (ag + ' ' + ('daysago' | translate)) }})</span>
      }
    </div>
  }
  @if (column.name === 'created_by' || column.name === 'archived_by') {
    <div>
      {{ item[column.name] }}
    </div>
  }
</ng-template>
